// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"8bdff003e075faf6","6831":"c582556d19b8d638","8503":"7deffa9796740b5b","9683":"d7a05d5d698acf7a"}[chunkId] + ".js";
};